import { Helmet } from "react-helmet-async";
import EnrollmentForm from "../components/EnrollmentForm";
import enrollTranslations from "../locales/enrollTranslations";
import { useContext } from "react";
import { LanguageContext } from "../locales/LanguageContext";
import assessmentStatusEnum from "../utils/assessmentstatusEnum";

const Enroll = () => {
  const { lang } = useContext(LanguageContext);
  const t = enrollTranslations[lang] || {};
  return (
    <>
      <Helmet>
        <title>{t.pageTitle} | AKAAL KIDS</title>
      </Helmet>
      <div
        style={{
          width: "100%",
          background: "linear-gradient(90deg, #f6815e 0%, #f6b93b 100%)",
          color: "#fff",
          padding: "38px 0 24px 0",
          textAlign: "center",
          marginBottom: 32,
          boxShadow: "0 4px 24px #f6815e22",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <h1
          style={{
            fontWeight: 900,
            fontSize: "2.6rem",
            letterSpacing: 1,
            marginBottom: 11,
            textShadow: "0 2px 12px #f6815e55",
          }}
        >
          {t.pageTitle}
        </h1>
        <div style={{ fontSize: 20, fontWeight: 500, opacity: 0.96 }}>
          <span role="img" aria-label="profile">
            👤
          </span>{" "}
          {t.subtitle}
        </div>
      </div>
      <div
        className="container"
        style={{ fontSize: "1.18em", marginTop: -18, marginBottom: 24 }}
      >
        <EnrollmentForm
          endpoint="learner-enrollments"
          showModalInfo={true}
          extraFields={{
            assessmentStatus: assessmentStatusEnum.PENDING,
            isQrEnrollment: false,
            configAppId: 1,
          }}
          showSuccessMessage={true}
          submitButtonLabel={t.submitBtn}
        />
      </div>
    </>
  );
};
export default Enroll;
